<template>
  <div class="navbar">
    <div class="mobile-menu" @click="toggleSideBar">
      <i class="el-icon-s-unfold"></i>
    </div>

    <div class="logo" @click="goToLink('/hotcontrols')">
      <img src="../../src/assets/stockantsLogo.png" alt="StockAnts-Logo" />
    </div>

    <div class="navbarContent" v-if="userRoles.includes('StockAnts Admin') || (userProfile && ['bhushanm705811@gmail.com', 'satavchetan08@gmail.com', 'sumittarkas0001@gmail.com', 'krishaa0801@gmail.com', 'snehalvpatil25@gmail.com', 'joshiakshay719@gmail.com', 'fegde.mayur@gmail.com'].includes(userProfile.email))">
      <!-- <div class="cursor-pointer menu-links" @click="goToLink('/dashboard')"
        :style="[active_link == '/dashboard' ? { color: '#e72726' } : {}]">
        Dashboard
      </div>
      <div class="cursor-pointer menu-links" @click="goToLink('/hotcontrols')"
        :style="[active_link == '/hotcontrols' ? { color: '#e72726' } : {}]">
        Hotcontrols
      </div> -->


      <div class="cursor-pointer menu-links" @click="goToLink('/broker-dashboard-analytics')" :style="[
        active_link == '/broker-dashboard-analytics' ? { color: '#e72726' } : {},
      ]">
        User Dashboard
      </div>

      <div class="cursor-pointer menu-links" @click="goToLink('/user-plans')"
        :style="[active_link == '/user-plans' ? { color: '#e72726' } : {}]">
        Plans Dashboard
      </div>

      <div class="cursor-pointer menu-links" @click="goToLink('/trade-dashboard-analytics')" :style="[
        active_link == '/trade-dashboard-analytics'
          ? { color: '#e72726' }
          : {},
      ]">
        Trade Dashboard
      </div>

      <div v-if="selected_broker && selected_broker.title !== 'Supernal ventures'" class="cursor-pointer menu-links"
        @click="goToLink('/expert-view')" :style="[active_link == '/expert-view' ? { color: '#e72726' } : {}]">
        Expert View
      </div>
    </div>

    <div class="navbarContent" v-else>
      <div class="cursor-pointer menu-links" @click="goToLink('/broker-dashboard-analytics')" :style="[
        active_link == '/broker-dashboard-analytics'
          ? { color: '#e72726' }
          : {},
      ]" v-if="userRoles.includes('Broker Admin')">
        User Dashboard
      </div>

      <div class="cursor-pointer menu-links" @click="goToLink('/trade-dashboard-analytics')" :style="[
        active_link == '/trade-dashboard-analytics'
          ? { color: '#e72726' }
          : {},
      ]" v-if="this.userProfile && ['ankit.yadav@myfindoc.com', 'omar@navia.co.in'].includes(this.userProfile.email)">
        Trade Dashboard
      </div>

      <div v-if="selected_broker && selected_broker.title !== 'Supernal ventures'" class="cursor-pointer menu-links"
        @click="goToLink('/expert-view')" :style="[active_link == '/expert-view' ? { color: '#e72726' } : {}]">
        Expert View
      </div>
    </div>
    <div v-if="!userRoles.includes('Broker Associate')">
      <div class="flex">
        <el-select v-model="selectedBrokerId" size="mini" placeholder="Brokers" filterable
          style="width: 130px; margin-right: 18px;" @change="storeSelectedBrokerDetails()" v-if="brokerList && brokerList.length > 1">
          <el-option v-for="(broker, index) in brokerList" :key="index" :label="broker.title" :value="broker.id">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="right-section">
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          <div class="user-profile">
            <div class="username capitalize">{{ userProfile.full_name }}</div>
            <div class="avatar">
              {{ userProfile.full_name ? userProfile.full_name[0] : "" }}
            </div>
          </div>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="createAccount" v-if="$route.path != '/create-user' && userRoles.includes('StockAnts Admin')">
            Create Broker Account
          </el-dropdown-item>
          <el-dropdown-item :disabled="isLogoutLoading" command="logout">
            <i v-if="isLogoutLoading" class="el-icon-loading" style="margin-right: 5px;"></i>
            Logout
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <div>
      <div v-if="drawerVisible" class="sideBarBackground" @click="closeSideBar">
        <div class="sideBar" @mouseover="mouseOver" @mouseleave="mouseLeave" @click.stop>
          <i class="el-icon-close close-icon" @click="closeSideBar"></i>
          <div class="sideBar-logo-section" @click="goToLink('/hotcontrols')">
            <img src="../../src/assets/stockantsLogo.png" alt="StockAnts-Logo" class="stockants-logo" />
          </div>
          <div v-if="userRoles.includes('StockAnts Admin')">
            <div class="cursor-pointer menu-links menu-item" style="padding: 15px;" @click="goToLink('/dashboard')"
              :style="[active_link == '/dashboard' ? { color: '#e72726' } : {}]">
              Dashboard
            </div>
            <div class="cursor-pointer menu-links menu-item" style="padding: 15px;" @click="goToLink('/hotcontrols')"
              :style="[
                active_link == '/hotcontrols' ? { color: '#e72726' } : {},
              ]">
              Hotcontrols
            </div>

            <div class="cursor-pointer menu-links"  style="padding: 15px;"  @click="goToLink('/broker-dashboard-analytics')" :style="[
              active_link == '/broker-dashboard-analytics'
                ? { color: '#e72726' }
                : {},
            ]">
              User Dashboard
            </div>
            <div class="cursor-pointer menu-links menu-item" style="padding: 15px;" @click="goToLink('/user-plans')"
              :style="[
                active_link == '/user-plans' ? { color: '#e72726' } : {},
              ]">
              Plans Dashboard
            </div>
          </div>
          <div v-else>
            <div class="cursor-pointer menu-links menu-item" style="padding: 15px;"
              @click="goToLink('/broker-dashboard-analytics')" :style="[
                active_link == '/broker-dashboard-analytics'
                  ? { color: '#e72726' }
                  : {},
              ]" v-if="userRoles == 'Broker Admin'">
              User Dashboard
            </div>

            <div class="cursor-pointer menu-links  menu-item" style="padding: 15px;"
              @click="goToLink('/trade-dashboard-analytics')" :style="[
                active_link == '/trade-dashboard-analytics'
                  ? { color: '#e72726' }
                  : {},
              ]" v-if="this.userProfile && ['ankit.yadav@myfindoc.com', 'omar@navia.co.in'].includes(this.userProfile.email)">
              Trade Dashboard
            </div>

            <div v-if="selected_broker && selected_broker.title !== 'Supernal ventures'"
              class="cursor-pointer menu-links  menu-item" style="padding: 15px;" @click="goToLink('/expert-view')"
              :style="[active_link == '/expert-view' ? { color: '#e72726' } : {}]">
              Expert View
            </div>

          </div>
          <div class="logout-container">
            <div class="cursor-pointer menu-links menu-item" @click="logout"
              style="position: fixed; bottom: 0; width: 160px; background-color: #fff; border-top: 1px solid #e4e6ec; text-align: left; padding:15px 10px 10px 10px">
              Logout
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { serverAddr } from "@/networkConfig";
import { mapState, mapMutations } from "vuex";
import { screenSize } from "../mixins/ScreenSize.js";
import { EventBus } from "../eventBus";

export default {
  name: "NavBar",
  mixins: [screenSize],
  data() {
    return {
      drawer: false,
      userProfile: {},
      // brokerList: [],
      userRoles: localStorage.getItem("userRoles")
        ? localStorage.getItem("userRoles")
        : [],
      active_link: "",
      drawerVisible: false,
      selectedBrokerId: null,
      isLogoutLoading: false,
    };
  },

  computed: {
    brokerList() {
      return this.$store.state.broker_list
        ? this.$store.state.broker_list
        : null;
    },

    selected_broker() {
      return this.$store.state.selected_broker
        ? this.$store.state.selected_broker
        : null;
    },
  },
  watch: {
    selected_broker(newValue, oldValue) {
      if (newValue) {
        this.selectedBrokerId = newValue.id;
      }
    },
  },
  mounted() {
    if (this.$store.state.selected_broker) {
      this.selectedBrokerId = this.$store.state.selected_broker.id;
    }
    this.fetchUserProfile();
    this.active_link = this.$route.path;
    EventBus.$on("openSidebar", this.openSideBar);
  },
  methods: {
    ...mapMutations(["resetAllState"]), // Map the resetAllState mutation
    storeSelectedBrokerDetails() {
      const filteredBroker = this.brokerList.find(
        (broker) => broker.id === this.selectedBrokerId
      );
      this.$store.commit("commitSelectedBroker", filteredBroker);
    },
    toggleSideBar() {
      this.drawerVisible = !this.drawerVisible;
      this.updateBodyOverflow();
    },
    closeSideBar() {
      this.drawerVisible = false;
      this.updateBodyOverflow();
    },
    updateBodyOverflow() {
      document.body.style.overflow = this.drawerVisible ? "hidden" : "auto";
    },
    mouseOver() {
      document.body.style.overflow = "hidden";
    },
    mouseLeave() {
      if (!this.drawerVisible) {
        document.body.style.overflow = "auto";
      }
    },
    fetchUserProfile() {
      const profileData = localStorage.getItem("profileData");
      if (profileData) {
        this.userProfile = JSON.parse(profileData);
      }
    },
    goToLink(link) {
      if (link) {
        this.$router.push(link);
      }
    },
    handleSelect(index) {
      this.activeIndex = index;
    },
    handleOpen(index, indexPath) {
      console.log(index, indexPath);
    },
    handleClose(index, indexPath) {
      console.log(index, indexPath);
    },
    closeDrawer() {
      this.drawer = false;
    },
    handleCommand(command) {
      if (command === "logout") {
        this.logout();
      } else if (command === "createAccount") {
        this.$router.push('/create-user')
      }
    },
    async logout() {
      this.isLogoutLoading = true;
      try {
        const refresh_token = localStorage.getItem("refresh_token");
        const response = await serverAddr.post(
          "/admin_dashboard/admin_logout",
          { refresh_token }
        );
        if (response.data.status) {
          localStorage.clear();
          this.resetAllState(); // Call the resetAllState mutation
          this.$router.push({ name: "LogIn" });
        } else if (response.data.validation) {
          this.$router.push(response.data.redirect);
        } else {
          console.error("Logout failed");
        }
      } catch (error) {
        console.error("Error during logout:", error);
      }
    },
  },
  beforeDestroy() {
    EventBus.$off("openSidebar", this.openSideBar);
  },
};
</script>
<style scoped>
body {
  margin: 0;
  font-family: Arial, sans-serif;
}

.mobile-menu {
  cursor: pointer;
}

.close-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 15px;
  cursor: pointer;
}

.el-icon-s-unfold {
  font-size: 24px;
}

.sideBarBackground {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.sideBar {
  position: fixed;
  top: 0;
  left: 0;
  width: 180px;
  height: 100%;
  background: white;
  z-index: 1000;
  transition: left 0.3s ease;
  /* padding-top: 50px; */
}

.sideBar-logo-section {
  padding: 0px 5px 0px 5px;
  font-size: 1.5rem;
  color: #fff;
  font-weight: 300;
  line-height: 30px;
  border-width: thin;
}

.stockants-logo {
  width: 140px;
  height: 100%;
}

.sideBar-menu-section {
  margin: 0 0 15px;
  padding: 0 0 3px;
  overflow: auto;
}

.menu-item {
  cursor: pointer;
  padding: 12px 20px 12px 20px;
  text-decoration: none;
  font-size: 0.8rem;
  color: #111112;
  transition: 0.3s;
  text-decoration: none;
  font-weight: 500;
  border-top: 1px solid #e4e6ec;
}

.logout-container {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  border-top: 1px solid #e4e6ec;
}

.main {
  transition: margin-left 0.3s ease;
}
</style>
<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";

.navbar {
  background: #fff;
  display: flex;
  align-items: center;
  box-shadow: 0 0 12px 1px rgba(0, 0, 0, 0.1);
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  height: 60px;
  z-index: 11;
  margin-bottom: 10px;
}

.navbarContent {
  flex: 1;
  display: flex;
  align-items: center;
  margin-left: 0px;
}

.right-section {
  display: flex;
  align-items: center;
  margin-right: 16px;
}

.user-profile {
  display: flex;
  align-items: center;
}

.username {
  margin-right: 10px;
  font-weight: 600;
  color: #777777;
}

.avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #e72726;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-weight: 600;
}

.publish-btn {
  height: 22px;
  line-height: 5;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 10px;
  outline: none;
  border-radius: 6px;
  color: #fff !important;
  border: 1px solid #e72726;
  background: #e72726;
  margin: 0 5px;
}

.menu-links {
  padding: 0 9px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #777777;
}

.menu-links:hover {
  color: #e72726;
}

.active-menu-link {
  color: #e72726;
}

.logo img {
  /* height: 60px; */
  width: 160px;
  margin-right: 20px;
  margin-left: 20px;
}

.logo img:hover {
  cursor: pointer;
}

.navbar-menu {
  border-bottom: none;
  text-decoration: none;
}

.mobile-menu {
  display: none;
  margin-left: 16px;
  font-size: 22px;
  cursor: pointer;
}

@media (max-width: 500px) {
  .logo img {
    width: 140px;
    margin-right: 0px;
    margin-left: 0px;
  }
}

@media (max-width: 996px) {
  .navbarContent {
    display: none;
  }

  .mobile-menu {
    display: block;
  }

  /* profile section hide below 768px screen */
  .right-section {
    display: none;
  }
}

.el-drawer {
  z-index: 1000 !important;
  /* Ensure the drawer has a higher z-index */
}

.el-drawer__body {
  padding: 16px;
  /* Add padding to drawer body */
}

.mobile-drawer {
  width: 250px !important;
}

.drawer-content .menu-links {
  display: block;
  margin-bottom: 10px;
  font-size: 16px;
}

.v-modal {
  z-index: 999 !important;
  /* Ensure modal has lower z-index than drawer */
}
</style>

<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.el-dropdown-menu__item:hover {
  background-color: #ecf5ff;
  color: red !important;
}
</style>
